import $ from 'jquery';
import zip from 'lib/util/zip';
import tdaConfig from 'lib/util/tda.config';
import dealerSearchModal from './dealer.search.modal';
import cookies from 'utils/cookies';
import zipTools from 'components/zip-tools';
import paramByName from 'lib/getParameterByName';
import storageUtil from 'utils/storage-util';
import rtiCheck from 'lib/gxp/dealers.rti.check';
import rtiDealerCode from 'lib/gxp/rtiDealerCode';

var __oneYear = new Date(Date.now() + (365 * 24 * 60 * 60 * 1000));
var __cookieName = 'dealer_code_rti_code';
var __thisHref = null;

// todo: deal with offer URLs too
function __gxpUrl(href) {
  var qs = $.param({
    series: paramByName('series', href),
    dealerCd: rtiDealerCode.savedDealerCode(),
    zipcode: zip.getCookiedDefaultFallback(),
  });
  return `/${tdaConfig.site.context_url}/inventory/search/?${qs}`;
}

var gxpCta = {
  // dealerSelect invoked via dealer.search.modal, after dealer select within modal
  // or within GXP checking directly, below
  dealerSelect: function (e, selectedDealer, newZip) {
    e && e.preventDefault(); // eslint-disable-line no-unused-expressions
    var rtiDealer = selectedDealer.isRti;
    // console.log('selectedDealer: ', selectedDealer);
    cookies.setItem(
      __cookieName,
      String(rtiDealer ? selectedDealer.dealerCode : 'false'), // cookie val is false or the dealerCode of rti participant
      __oneYear,
      '/',
      zipTools.getCrossDomainCookieDomain()
    );

    storageUtil.setConfirmedZip(true);
    storageUtil.setZip(newZip || selectedDealer.zipCode);

    if (rtiDealer) {
      window.location.href = __gxpUrl(__thisHref);
    } else {
      window.location.href = __thisHref;
    }
  },

  // invoked dealer.search.modal if user dismisses the ENTER zip modal
  modalDismiss: function () {
    cookies.setItem(__cookieName, 'false', __oneYear, '/', zipTools.getCrossDomainCookieDomain());
    window.location.href = __thisHref;
  }
};

Object.setPrototypeOf(gxpCta, dealerSearchModal);

export default function ($scope, $selector) {
  var $ctaScope = $scope || $('body');
  var $ctas = $($selector, $ctaScope);

  if (!$ctas.length) return;

  $ctas.on('click.gxp', function (e) {
    e.preventDefault();
    var cookiedCode = rtiDealerCode.savedDealerCode();
    var confirmed = cookies.getItem('isConfirmedZip') === 'true';
    var userZip = zip.getCookiedDefaultFallback();
    __thisHref = $(this).attr('href');

    // we have a cookied dealerCode and its false
    // user has already been through GXP process, just move along
    if (cookiedCode && cookiedCode == 'false') {
      window.location.href = __thisHref;
    } else if (cookiedCode) {
      // we have a cookied dealerCode val, user has an RTI dealer
      window.location.href = __gxpUrl(__thisHref);
    } else if (confirmed && userZip) {
      // if zip confirmed AND confirmed zip contains RTI participant, then prompt
      rtiCheck(userZip)
        .then(pmaRes => {
          if (!pmaRes) {
            window.location.href = __thisHref;
          } else if (pmaRes.length === 1) {
            gxpCta.dealerSelect(null, pmaRes[0], userZip);
          } else {
            gxpCta.setMode('pma');
            gxpCta.beginSearch(userZip);
          }
        })
        // if there's any type of error, just set GXP cookie to 'false' and carry on
        .catch(err => {
          console.log('err: marking GXP cookie as false and moving on', err); // eslint-disable-line no-console
          cookies.setItem(__cookieName, String('false'), __oneYear, '/', zipTools.getCrossDomainCookieDomain());
          window.location.href = __thisHref;
        });
    } else {
      // no confirmed zip, need to ask
      gxpCta.setMode('autoSelectSinglePMA');
      gxpCta.enterZip(userZip);
    }
  });
};
